import {FieldValue} from "firebase/firestore";

type DeepUndefinedRemover<T> = T extends object
  ? T extends Array<infer U>
    ? DeepUndefinedRemover<U>[] // If T is an array, apply recursively to each element
    : {[K in keyof T]: DeepUndefinedRemover<T[K]>} // If T is an object, apply recursively to each property
  : T; // For non-objects (primitives), keep the type as is

export function removeUndefined<T>(obj: T): DeepUndefinedRemover<T> {
  if (obj instanceof FieldValue || obj instanceof Date)
    return obj as DeepUndefinedRemover<T>;
  else if (Array.isArray(obj)) {
    // Handle arrays: recursively process each element
    return obj
      .map((item) => removeUndefined(item))
      .filter((item) => item !== undefined) as DeepUndefinedRemover<T>;
  } else if (typeof obj === "object" && obj !== null) {
    // Handle objects: recursively process each property
    const result: any = {};

    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const value = (obj as any)[key];
        if (value !== undefined) {
          result[key] = removeUndefined(value);
        }
      }
    }

    return result;
  }

  // For non-objects and non-arrays (primitives), return the value as is
  return obj as DeepUndefinedRemover<T>;
}
